import { DiceRollResult, DiceRoller, ExpressionRoll, RollBase } from 'dice-roller-parser';

/* github.com/3d-dice/dice-roller-parser#MathFunctionRoll */
/* help.roll20.net/hc/en-us/articles/360037773133-Dice-Reference */
export class Dice {
    private static roller = new DiceRoller(() => {
        return crypto.getRandomValues(new Uint32Array(1))[0] / 4294967295;
    });

    public static interpolate(text: string) {
        const tokens = text.split(' ');
        const interpolated = tokens.map((token) => {
            if (!token.match(/\d*[dD]\d+/gm)) return token;
            const rolls = Dice.roll(token);
            if (rolls?.length) {
                return `[${rolls.map(roll => roll.value).join(', ')}]`;
            }
            return token;
        });
        return interpolated.join(' ');
    }

    public static roll(input: string): RollBase[] | undefined {
        const trimmedInput = input.trimStart();
        const bulkdice = trimmedInput.match(/^(\d*)#(.*)/) ?? [];
        const diceprompt = bulkdice.length === 3
            ? bulkdice[2].toString().toLowerCase()
            : trimmedInput.toLowerCase();

        if (Dice.tryRolling(Dice.parse(diceprompt)) == undefined) return undefined;

        let iterations = bulkdice.length == 3 ? Math.min(parseInt(bulkdice[0].toString()), 20) : 1;

        const results: RollBase[] = [];
        for (let i = 0; i < iterations; i++) {
            const rollbase = Dice.tryRolling(Dice.parse(diceprompt)) as RollBase;
            results.push(rollbase);
        }
        return results;
    }

    private static tryRolling(rollbase: RollBase | undefined) {
        const invalidLonelyTypes = ['number', 'mathfunction'];
        const invalidTypes = ['fate', 'fateroll'];
        const roll = rollbase as DiceRollResult;
        const group = rollbase as ExpressionRoll;
        const groupdice = group?.dice as DiceRollResult[];
        if (rollbase == undefined) return undefined;
        if (roll.die && invalidTypes.includes(roll.die.type)) return undefined;
        if (group.dice && groupdice.find(x => invalidTypes.includes(x.die?.type))) return undefined;
        if (group.dice == undefined && roll.die == undefined) return undefined;
        if (group.dice && group.dice.every(x => invalidLonelyTypes.includes(x.type))) return undefined;

        return rollbase;
    }

    private static parse(input: string) {
        try {
            return this.roller.roll(input);
        } catch (e) {
            try {
                return this.roller.roll(input.slice(1));
            } catch (e) {
                try {
                    return this.roller.roll(input.replace(/(!|\/|\.)?(rollme|roll|rr|r)\s+/, ''));
                } catch (e) {
                    return undefined;
                }
            }
        }
    }
}
